export const products = [
  {
    id: 1,
    name: "Men's Andean Alpaca Sweater - Medium",
    price: 54.99,
    category: "Men",
    size: "Medium",
    image: "/assets/Man-Sweater3.jpg",
    images: ["/assets/Man-Sweater3.jpg", "/assets/Man-Sweater4.jpg", "/assets/SweaterMan.jpg", "/assets/Man-Sweater6.jpg"],
    description: "Handcrafted Andean alpaca sweater for men - Medium size"
  },
  {
    id: 2,
    name: "Men's Andean Alpaca Sweater - Large",
    price: 54.99,
    category: "Men",
    size: "Large",
    image: "/assets/Man-Sweater4.jpg",
    images: ["/assets/Man-Sweater4.jpg", "/assets/Man-Sweater3.jpg", "/assets/SweaterMan.jpg", "/assets/Man-Sweater6.jpg"],
    description: "Handcrafted Andean alpaca sweater for men - Large size"
  },
  {
    id: 3,
    name: "Women's Andean Alpaca Sweater - Medium",
    price: 54.99,
    category: "Women",
    size: "Medium",
    image: "/assets/Female-Sweater3.jpg",
    images: ["/assets/Female-Sweater3.jpg", "/assets/Female-Sweater4.jpg", "/assets/Female-Sweater5.jpg", "/assets/Female-Sweater1.jpg", "/assets/Female-Sweater2.jpg"],
    description: "Handcrafted Andean alpaca sweater for women - Medium size"
  },
  {
    id: 4,
    name: "Women's Andean Alpaca Sweater - Large",
    price: 54.99,
    category: "Women",
    size: "Large",
    image: "/assets/Female-Sweater4.jpg",
    images: ["/assets/Female-Sweater4.jpg", "/assets/Female-Sweater3.jpg", "/assets/Female-Sweater5.jpg", "/assets/Female-Sweater1.jpg", "/assets/Female-Sweater2.jpg"],
    description: "Handcrafted Andean alpaca sweater for women - Large size"
  },
  {
    id: 5,
    name: "Women's Alpaca Poncho - Gray",
    price: 25.99,
    category: "Women",
    color: "Gray",
    image: "/assets/Female-Poncho-Gray1.jpg",
    images: ["/assets/Female-Poncho-Gray1.jpg", "/assets/Female-Poncho-Red1.jpg", "/assets/Female-Poncho-Red2.jpg"],
    description: "Beautiful handwoven alpaca poncho in gray",
    grayscale: true
  },
  {
    id: 6,
    name: "Women's Alpaca Poncho - Red",
    price: 25.99,
    category: "Women",
    color: "Red",
    image: "/assets/Female-Poncho-Red2.jpg",
    images: ["/assets/Female-Poncho-Red2.jpg", "/assets/Female-Poncho-Red1.jpg", "/assets/Female-Poncho-Red4.jpg"],
    description: "Beautiful handwoven alpaca poncho in red"
  },
  {
    id: 7,
    name: "Women's Alpaca Poncho - Brown",
    price: 25.99,
    category: "Women",
    color: "Brown",
    image: "/assets/Female-Poncho-Brown1.jpg",
    images: ["/assets/Female-Poncho-Brown1.jpg", "/assets/Female-Poncho-Brown2.jpg", "/assets/Female-Poncho-Brown3.jpg", "/assets/Female-Poncho-Brown4.jpg"],
    description: "Beautiful handwoven alpaca poncho in brown"
  }
];

export const categories = ["All", "Men", "Women"];
